/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Only_Still_Impala_FlowInputs */

const fr_only_still_impala_flow = /** @type {(inputs: Only_Still_Impala_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun drop-in récent`)
};

/**

* @param {Only_Still_Impala_FlowInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const only_still_impala_flow = /** @type {((inputs?: Only_Still_Impala_FlowInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Only_Still_Impala_FlowInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_only_still_impala_flow(inputs)
});